import router from '@/router'

export const getLocale = () => (
    (router.app && router.app.$i18n.locale)
        ? router.app.$i18n.locale : 'en'
)